import axios from "axios";
import { defaultSettings } from "contexts/appsettings/defaultSettings";
import { isBoolean } from "lodash";
import { REACT_APP_BACKENDURL } from "../../../config";
import { CommentableEntityType } from "../notifications/interface";

export interface SubscriptionStatusLoaderData {
  isSubscribed: boolean;
}

/**
 * Constructs the subscription status URL based on the entity type and ID.
 *
 * @param entityType - The type of the entity (e.g., "TlfItem", "Hierarchy").
 * @param entityId - The unique identifier of the entity.
 * @returns The constructed subscription status URL.
 */
const getSubscriptionUrl = (entityType: CommentableEntityType, entityId: string): string => {
  const backEndUrl = REACT_APP_BACKENDURL.includes("_REACT_APP_BACKENDURL_")
    ? defaultSettings.backEndUrl
    : REACT_APP_BACKENDURL;

  return `${backEndUrl}Comments/${entityType}/${entityId}/GetSubscriptionStatus`;
};

/**
 * Loader for comment subscription status.
 *
 * @param props - Loader args from react-router
 * @param props.params - Route params
 * @param props.params.entityType - Entity type to check
 * @param props.params.entityId - Entity id to check
 * @returns Subscription status loader data
 */
export const getSubscriptionStatusLoaderData = async ({
  params,
}: {
  params: {
    entityType: CommentableEntityType;
    entityId: string;
  };
}): Promise<SubscriptionStatusLoaderData> => {
  const subscriptionStatusLoaderData = await axios.get(
    getSubscriptionUrl(params.entityType, params.entityId),
  );

  if (
    !subscriptionStatusLoaderData ||
    subscriptionStatusLoaderData.data === undefined ||
    !isBoolean(subscriptionStatusLoaderData.data)
  ) {
    throw new Error("Invalid or No response from SubscriptionStatus Loader");
  }
  return {
    isSubscribed: subscriptionStatusLoaderData.data,
  };
};
